/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ShippingFees {
    class ShippingFeesController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
        // statically inject constructor resources
        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            "meevo.components.short-cuts.ShortCutsService",
            "meevo.components.busy.BusyService",
            "$translate",
        ];

        public issingleLocation: boolean = false;
        public searchCriteria = null;

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected dataService: Meevo.Components.BaseClasses.IDataService,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    protected identityService: Meevo.Components.Common.IIdentityService,
                    protected loggingService: Meevo.Components.Logging.ILoggingService,
                    protected securityService: Meevo.Components.Common.ISecurityService,
                    protected trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected $rootScope: angular.IRootScopeService,
                    protected $scope: angular.IScope,
                    protected $state: any,
                    protected contextParams: Meevo.IContextParams,
                    protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $translate: angular.translate.ITranslateService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

        }

        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.REGISTER_SHIPPINGFEES).then(() => {
                this.context = new ShippingFeesContext(
                    this.appSettings,
                    this.dataService,
                    this.modalService,
                    this.identityService,
                    this.loggingService,
                    this.securityService,
                    this.trackingService,
                    this.busyService
                );

                this.context.activate(this.selectedItemId, null, this.asLocationId);

                this.context.deactivate = () => {
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                };

                this.context.locationFieldList = [
                    { field: 'ObjectState', label: this.$translate.instant("LABEL_ACTIVE"), checked: false },
                    { field: 'Price', label: this.$translate.instant("LABEL_PRICE_LEVEL"), checked: false },
                    { field: 'ShowInEgift', label: this.$translate.instant("LABEL_SELECTED_SHOW_IN_EGIFT"), checked: false },
                ];

            }).finally(() => {
                this.busyService.stop();
            });
        }

    }

    angular.module("meevo.plugins.shippingFees")
        .controller("meevo.plugins.shippingFees.ShippingFeesController", ShippingFeesController);
}